import { render } from "./withdrawalManage.vue?vue&type=template&id=3223cc8a&scoped=true"
import script from "./withdrawalManage.vue?vue&type=script&lang=js"
export * from "./withdrawalManage.vue?vue&type=script&lang=js"

import "./withdrawalManage.vue?vue&type=style&index=0&id=3223cc8a&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3223cc8a"]])

export default __exports__